import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function apiErr(err, fallback = "Errore") {
  const d = err?.response?.data?.detail;
  if (!d) {
    const raw = err?.message || "";
    // Cloudflare/HTML page → mai mostrare HTML raw, restituisci messaggio pulito
    if (/cloudflare|<!doctype|<html|sent a response/i.test(raw)) {
      return "Servizio momentaneamente non disponibile. Riprova tra qualche istante.";
    }
    return raw || fallback;
  }
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(", ");
  if (typeof d === "string") {
    if (/cloudflare|<!doctype|<html|sent a response/i.test(d)) {
      return "Servizio momentaneamente non disponibile. Riprova tra qualche istante.";
    }
    return d;
  }
  return JSON.stringify(d);
}

/** True se l'errore è dovuto a un proxy/CDN intermedio (502/503/504, oppure body HTML).
 *  Utile per decidere quando applicare fallback locali (es. visita sana). */
export function isUpstreamFailure(err) {
  const s = err?.response?.status;
  if (s === 502 || s === 503 || s === 504 || s === 520 || s === 521 || s === 522) return true;
  const detail = err?.response?.data?.detail;
  const txt = typeof detail === "string" ? detail : (err?.response?.data ? JSON.stringify(err.response.data).slice(0, 500) : "");
  return /cloudflare|<!doctype|<html|sent a response/i.test(txt);
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("pv_token");
      localStorage.removeItem("pv_user");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
